module.exports = __webpack_public_path__ + "static/media/IMG-25.aa1a9eb9.jpg";